import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

// OBTENER TODAS LAS CATEGORIAS
export const obtenerUnits = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Unit`, "GET");
  return respuesta;
};

// OBTENER TODAS LAS CATEGORIAS
export const obtenerUnitsAct = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Unit/UnitsAct`, "GET");
  return respuesta;
};

// MODIFICAR CATEGORIA
export const addUnit = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Base/Global/Unit/add`,
    "POST",
    data
  );
  return respuesta;
};
